import React from 'react';
import { ChannelType } from 'src/components/Channels/useChannelForm';
import {
  MessagesNotificationBadge,
  FilesNotificationBadge,
  FormsNotificationsBadge,
  InvoiceNotificationsBadge,
  InboxNotificationBadge,
} from '.';

export const useNotificationsBadge = (entityType: ChannelType) => {
  switch (entityType) {
    case 'messaging':
      return <MessagesNotificationBadge />;
    case 'files':
      return <FilesNotificationBadge />;
    case 'forms':
      return <FormsNotificationsBadge />;
    case 'billing':
      return <InvoiceNotificationsBadge />;
    case 'inbox':
      return <InboxNotificationBadge />;
    default:
      return null;
  }
};
